/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import deliverySheet from '../action/deliverySheetAction'

export const initialState = ({
  isLoading: false,
  deliverySheets: null,
  status: null,
})


export default function (state = initialState, action) {
  switch (action.type) {

    case deliverySheet.TYPES.REQUEST_DELIVERY_SHEET:
      return Object.assign({}, state, { deliverySheets: null, isLoading: true, status: null})

    case deliverySheet.TYPES.REQUEST_DELIVERY_SHEET_SUCCESS:
      return Object.assign({}, state, { deliverySheets: action.payload, isLoading: false, status: null})

    case deliverySheet.TYPES.REQUEST_DELIVERY_SHEET_FAILED:
      return Object.assign({}, state, { deliverySheets: null, isLoading: false, status: null})

    case deliverySheet.TYPES.UPDATE_SHEET_LIST:
      return Object.assign({}, state, { deliverySheets: action.payload, isLoading: false, status: null})

    default:
      return state
  }
}
